import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

// Eager load only critical pages
import LandingEnhanced from '@/pages/LandingEnhanced';
import GoogleCallback from '@/pages/GoogleCallback';

// Lazy load all other pages for better performance
const Dashboard = lazy(() => import('@/pages/Dashboard'));
const HackathonDetailEnhanced = lazy(() => import('@/pages/HackathonDetailEnhanced'));
const OrganizerDashboard = lazy(() => import('@/pages/OrganizerDashboard'));
const JudgeDashboard = lazy(() => import('@/pages/JudgeDashboard'));
const AdminDashboard = lazy(() => import('@/pages/AdminDashboard'));
const Profile = lazy(() => import('@/pages/Profile'));
const PublicProfile = lazy(() => import('@/pages/PublicProfile'));
const About = lazy(() => import('@/pages/About'));
const Settings = lazy(() => import('@/pages/Settings'));
const PrivacyPolicy = lazy(() => import('@/pages/PrivacyPolicy'));
const TermsOfService = lazy(() => import('@/pages/TermsOfService'));
const VerifyEmail = lazy(() => import('@/pages/VerifyEmail'));
const VerificationRequired = lazy(() => import('@/pages/VerificationRequired'));
const ForgotPassword = lazy(() => import('@/pages/ForgotPassword'));
const ResetPassword = lazy(() => import('@/pages/ResetPassword'));

// Loading component
const LoadingScreen = () => (
  <div className="min-h-screen bg-gray-50 flex items-center justify-center">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-600 mx-auto mb-4"></div>
      <p className="text-gray-500">Loading...</p>
    </div>
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<LoadingScreen />}>
          <Routes>
            <Route path="/" element={<LandingEnhanced />} />
            <Route path="/auth/google/callback" element={<GoogleCallback />} />
            <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/hackathon/:slug" element={<HackathonDetailEnhanced />} />
        {/* Certificate routes removed */}
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/verification-required" element={<VerificationRequired />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/organizer" element={<OrganizerDashboard />} />
        <Route path="/judge" element={<JudgeDashboard />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/profile/:slug" element={<PublicProfile />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster position="top-right" expand={true} richColors />
    </div>
  );
}

export default App;
